// extracted by mini-css-extract-plugin
export var avatarContainer = "_7l-0";
export var avatarTypingWave = "_7l-i";
export var gray = "_7l-f";
export var green = "_7l-c";
export var icon = "_7l-9";
export var image = "_7l-1";
export var lg = "_7l-6";
export var md = "_7l-5";
export var presenceDot = "_7l-b";
export var red = "_7l-d";
export var sm = "_7l-4";
export var status = "_7l-a";
export var typingDot = "_7l-h";
export var typingPill = "_7l-g";
export var xl = "_7l-7";
export var xs = "_7l-3";
export var xxl = "_7l-8";
export var xxs = "_7l-2";
export var yellow = "_7l-e";